module.exports = __webpack_public_path__ + "static/origens_logo_4-ead94008199161179add1d75e9a04e74.png";